import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import Header from "../../components/Header/Header";
import s from "./SearchResults.module.scss";
import { useTranslation } from "react-i18next";
import { GetProps, Input, Table, Tooltip } from "antd";
import {
  getApplicationDetails,
  getMessagesList,
  searchApplications,
  setCurrentPageNumber,
  setLastSearchValue,
} from "../../redux/ApplicationSlice";
import { Link, useNavigate } from "react-router-dom";
import MobileApplicationsList from "../MobileApplicationsList/MobileApplicationsList";
import {
  ArrowLeftOutlined,
  CreditCardOutlined,
  EditOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { getExchangeRate } from "../../redux/BillingSlice";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { ColumnsType } from "antd/es/table";
import { getStatusTag } from "../../utils/functions";
import { getStatus } from "../../data";

import moment from "moment";
import { ICreateApplicationResponse } from "../../types";

const { Search } = Input;
type SearchProps = GetProps<typeof Input.Search>;

interface TableType {
  number: number;
  status: string;
  application_number: string;
  registration_date: string;
  user?: string;
}

const SearchResults = () => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const statusOptions = getStatus(t);
  const lastSearchValue = useSelector(
    (state: RootState) => state.application.lastSearchValue
  );
  const applicationsList = useSelector(
    (state: RootState) => state.application.searchResults
  );
  const columns: ColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Статус"),
      dataIndex: `status`,
      width: 400,
      render: (value: string) => getStatusTag(value, "lg", t),
      filters: statusOptions?.map(({ value, label }) => ({
        text: label,
        value: value,
      })),

      onFilter: (value, record) =>
        record?.status?.indexOf(value as string) === 0,
    },

    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },

    {
      title: t("Дата регистрации"),
      dataIndex: `registration_date`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Заявление"),
      dataIndex: `application`,
      width: 50,
    },

    {
      title: t("Оплата"),
      dataIndex: `payment`,
      width: 50,
      align: "center",
    },

    {
      title: t("История"),
      dataIndex: `history`,
      width: 0,
    },
    {
      title: t("Декларация"),
      dataIndex: `declaration`,
      width: 0,
    },
  ];
  const columns2: ColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Статус"),
      dataIndex: `status`,
      width: 400,
      render: (value: string) => getStatusTag(value, "lg", t),
      filters: statusOptions?.map(({ value, label }) => ({
        text: label,
        value: value,
      })),

      onFilter: (value, record) =>
        record?.status?.indexOf(value as string) === 0,
    },

    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },

    {
      title: t("Дата регистрации"),
      dataIndex: `registration_date`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Декларант"),
      dataIndex: `declarant`,
      width: 200,
    },
    {
      title: t("Заявление"),
      dataIndex: `application`,
      width: 50,
    },

    {
      title: t("Оплата"),
      dataIndex: `payment`,
      width: 50,
      align: "center",
    },

    {
      title: t("История"),
      dataIndex: `history`,
      width: 0,
    },
    {
      title: t("Декларация"),
      dataIndex: `declaration`,
      width: 0,
    },
  ];
  const user = useSelector((state: RootState) => state.user.user);

  const [data, setData] = useState<ICreateApplicationResponse[] | undefined>(
    applicationsList?.results
  );

  const [pagination, setPagination] = useState({
    current: applicationsList?.pagination?.current_page || 1,
    pageSize: applicationsList?.pagination?.page_size || 30,
    total: applicationsList?.pagination?.total_items || 100,
  });
  const [currentPage, setCurrentPage] = useState<number>(
    applicationsList?.pagination?.current_page || 1
  );
  const currentPageRef = useRef(currentPage);

  const onSearch: SearchProps["onSearch"] = async (value, _e, info) => {
    const res = await dispatch(
      searchApplications({ search_term: value, page: 1 })
    );
    dispatch(setLastSearchValue(value));
    console.log("res", res);
    if (searchApplications.fulfilled.match(res)) {
      setData(res.payload.results);
      navigate("/search-results");
    }
  };

  console.log("lastSearchValue", lastSearchValue);

  const getNextPage = async (page: number) => {
    setCurrentPage(page);
    dispatch(setCurrentPageNumber(page));
    currentPageRef.current = page;

    if (page === undefined || page === null) return;

    try {
      const res = await dispatch(
        searchApplications({ search_term: lastSearchValue, page })
      );
      if (!res.payload || !("results" in res.payload)) {
        console.error("Unexpected API response:", res);
        return;
      }

      if (res.type === "applications/searchApplications/fulfilled") {
        if ("results" in res.payload) {
          setData(res.payload.results);
          setPagination({
            current: res?.payload?.pagination?.current_page,
            pageSize: res?.payload?.pagination.page_size,
            total: res.payload.pagination.total_items,
          });
        } else {
          console.error("Unexpected API response:", res.payload);
        }
      }
    } catch (error) {
      console.error("Error in getNextPage:", error);
    }
  };

  const getPaymentAmount = async (id: number) => {
    const res = await dispatch(getApplicationDetails(id));
    if (res.type === "applications/getApplicationDetails/fulfilled") {
      navigate(`/payment/${id}`);
    }
  };

  const getMessages = async (id: number) => {
    const res = await dispatch(getMessagesList(Number(id)));

    if (res.type === "messages/getMessagesList/fulfilled") {
      navigate(`/messages/${id}`);
    }
  };

  return (
    <div>
      <Header />
      <div className={s.content}>
        <Link to="/home" className={s.back}>
          <ArrowLeftOutlined className={s.backIcon} /> {t("Назад")}
        </Link>
        <div className={s.top_header}>
          <div className={s.h2}>{t("Результаты поиска")}</div>
          <Search
            placeholder="input search text"
            allowClear
            enterButton
            size="small"
            onSearch={onSearch}
            className={s.search}
          />
        </div>
        <div className={s.form}>
          {width > 700 ? (
            <Table<TableType>
              bordered
              pagination={pagination}
              columns={user?.role === "admin" ? columns2 : columns}
              className="table"
              onChange={(pagination) => {
                if (pagination?.current) {
                  getNextPage(pagination.current);
                }
              }}
              dataSource={
                data &&
                data.map((it, index) => ({
                  key: it.id,
                  number: index + 1,
                  status: it.status,
                  application_number: it?.application_number,
                  registration_date: moment(it?.created_at).format(
                    "DD.MM.YYYY - HH:mm"
                  ),
                  // declarant: it?.assigned_declarant?.full_name,
                  // name: it?.user?.full_name,
                  payment:
                    it?.status === "new" ||
                    it?.status === "incomplete" ||
                    it?.status === "corrected" ? (
                      <div> {"-"} </div>
                    ) : (
                      <div
                        onClick={() => {
                          getPaymentAmount(it.id);
                          dispatch(getExchangeRate());
                        }}
                      >
                        <Tooltip title={t("Просмотреть оплату")} key={2}>
                          <CreditCardOutlined style={{ color: "gray" }} />
                        </Tooltip>
                      </div>
                    ),
                  application: (
                    <Link
                      to={
                        user?.role === "driver" ||
                        user?.role === "regional_manager"
                          ? `/application/${it?.id}`
                          : `/declarant/application/${it?.id}`
                      }
                      className={s.edit}
                      onClick={() => {
                        dispatch(getApplicationDetails(it.id));
                      }}
                    >
                      <Tooltip title={t("Просмотр/Редактирование")} key={1}>
                        <EditOutlined />
                      </Tooltip>
                    </Link>
                  ),
                  history: (
                    <div onClick={() => getMessages(it.id)} className={s.edit}>
                      {/* <Link to={`/messages/${it.id}`} className={s.edit}> */}
                      <Tooltip title={t("Просмотреть историю")} key={2}>
                        <MailOutlined />
                        {/* {(user?.role === "driver" ||
                          user?.role === "regional_manager") &&
                          it?.unread_message_count_owner > 0 && (
                            <div className={s.messages_count}>
                              {it.unread_message_count_owner}
                            </div>
                          )}
                        {user?.role === "broker" &&
                          it?.unread_message_count_declarant > 0 && (
                            <div className={s.messages_count}>
                              {it.unread_message_count_declarant}
                            </div>
                          )} */}
                      </Tooltip>

                      {/* </Link> */}
                    </div>
                  ),
                  // declaration: (
                  //   <div className={s.edit}>
                  //     {it.declaration ? (
                  //       <Link to={it.declaration} className={s.edit}>
                  //         <Tooltip title={t("Декларация")} key={4}>
                  //           <FileDoneOutlined />
                  //         </Tooltip>
                  //       </Link>
                  //     ) : (
                  //       "-"
                  //     )}
                  //   </div>
                  // ),
                }))
              }
            />
          ) : (
            <MobileApplicationsList />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
